import {Pipe, PipeTransform} from '@angular/core';
import {environment} from '@environments/environment';
import {UserTypeEnum} from '@shared/model/enum/user-type-enum';

@Pipe({
  name: 'userImage',
  standalone: true
})
export class UserImagePipe implements PipeTransform {

  imageBaseUrl: string = environment.ImageUrl;

  transform(userId: string, userType: UserTypeEnum, hasPhoto: boolean): string {
    let image = '';
    if (hasPhoto) {
      switch (userType) {
        case UserTypeEnum.Publisher:
          image = (`${this.imageBaseUrl}/publishers/` + userId + '.jpg');
          break;
        case UserTypeEnum.Author:
          image = (`${this.imageBaseUrl}/authors/` + userId + '.jpg');
          break;
        case UserTypeEnum.User:
          image = (`${this.imageBaseUrl}/avatars/` + userId + '.jpg');
          break;
        case UserTypeEnum.Club:
          image = (`${this.imageBaseUrl}/clubs/` + userId + '.jpg');
          break;
      }
    }
    else {
      image = 'https://cloud.behkhaan.ir/assets/images/default/default-avatar_room.svg';
    }
    return image;
  }

}
